<template>
  <el-form :model="query" label-width="100px" v-loading="loading">
    <el-row>
      <el-col :span="8">
        <el-form-item label="条件">
          <el-input
            v-model="query.keyword"
            maxlength="30"
            placeholder="姓名、身份证号、专家编号"
            clearable
            @keyup.enter.native="onSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="手机号">
          <el-input
            v-model="query.mobile"
            clearable
            maxlength="11"
            placeholder="请输入手机号"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="年龄" prop="age">
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="query.startAge"
                maxlength="2"
                placeholder="年龄开始"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="query.endAge"
                maxlength="3"
                placeholder="年龄结束"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="最高学历">
          <el-select
            v-model="query.education"
            filterable
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in data.educations"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="民族">
          <el-select
            v-model="query.nation"
            filterable
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in data.nations"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="性别">
          <el-select
            v-model="query.sex"
            placeholder="请选择"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in sexs"
              :key="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="研究学科">
          <el-cascader
            v-model="query.speId"
            :options="data.speTree"
            collapse-tags
            clearable
            style="width: 100%"
            @change="onSpeChange"
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item>
          <span slot="label">二级专业</span>
          <el-cascader
            :options="minorIds"
            @change="onMinorChange"
            clearable
            style="width: 100%"
          />
        </el-form-item>
      </el-col>

      <slot name="footer"></slot>
    </el-row>
    <el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="onSearch">
        搜索
      </el-button>
      <slot name="tip"></slot>
    </el-form-item>
  </el-form>
</template>

<script>
import { treeMinor } from '@/api/infos/minor.js';

export default {
  data() {
    return {
      query: {},
      loading: false,
      sexs: [
        {
          value: '男'
        },
        {
          value: '女'
        }
      ],
      minorIds: []
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    onSpeChange(value) {
      if (value && value.length > 0) {
        this.query.speId = parseInt(value[value.length - 1]);
        this.query.minorId = 0;
        this.treeMinor(this.query.speId);
      } else {
        this.query.speId = null;
      }
    },
    treeMinor(speId) {
      if (!speId) {
        return;
      }
      this.loading = true;
      treeMinor(speId).then(res => {
        this.minorIds = res;
        this.loading = false;
      });
    },
    onMinorChange(value) {
      if (value && value.length > 0) {
        this.query.minorId = parseInt(value[value.length - 1]);
      } else {
        this.query.minorId = null;
      }
    },
    onMajorChange(value) {
      this.query.majorIds = value.map(item => item[1]);
    },
    onSearch() {
      if (this.query.startAge && !Number.isInteger(this.query.startAge)) {
        this.msgError('年龄请输入数字值');
        return;
      }
      if (this.query.endAge && !Number.isInteger(this.query.endAge)) {
        this.msgError('年龄请输入数字值');
        return;
      }

      this.$emit('search', this.query);
    }
  }
};
</script>

<style></style>
